import {useEffect, useState} from 'react';

export const useFlagImgSrc = (countryCode?: string) => {
  const [imageSrc, setImageSrc] = useState();

  useEffect(() => {
    let isCancelled = false;

    if (countryCode) {
      import(`~/shared/images/flags/${countryCode.toUpperCase()}.svg`)
        .then(result => {
          if (!isCancelled) {
            setImageSrc(result.default);
          }
        })
        .catch(() => {
          isCancelled = true;
          setImageSrc(undefined);
        });
    }

    return () => {
      isCancelled = true;
    };
  }, [countryCode]);

  return imageSrc;
};
